import type { ReactNode } from 'react'
import { Box } from '@chakra-ui/react'
import { hexToRgba } from 'utils/banner-gradient'

interface IBannerActionButtonProps {
  /** The banner's resolved accent — the outline picks it up at half alpha. */
  accent: string
  label: string
  onClick: () => void
  /** Leading glyph, e.g. the Switch Org refresh icon. */
  icon?: ReactNode
}

/**
 * The pill action that sits beside a banner title (Manage team, Switch Org).
 *
 * One component so every banner action wears the same outline and fill: the
 * accent-tinted border is the only part that varies per organization.
 */
const BannerActionButton = ({ accent, label, onClick, icon }: IBannerActionButtonProps) => (
  <Box
    as="button"
    type="button"
    onClick={onClick}
    // Chakra does not reset the browser's default button border, which shows as a
    // white outline on this dark surface.
    border={`1px solid ${hexToRgba(accent, 0.5)}`}
    borderRadius="full"
    px="14px"
    h="30px"
    flexShrink={0}
    bg="rgba(255,255,255,0.06)"
    color="white"
    fontSize="12px"
    fontWeight={600}
    whiteSpace="nowrap"
    display="inline-flex"
    alignItems="center"
    gap="8px"
    _hover={{ bg: 'rgba(255,255,255,0.12)' }}
  >
    {icon}
    {label}
  </Box>
)

export default BannerActionButton
